import React from "react"
import styled, { css } from "styled-components"
import { Button } from "./Button"
import { IconType } from "./Icon"
import { Text } from "./Text"

const CardContainer = styled.div<{ pointer?: boolean }>`
  background-color: white;
  min-height: 250px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  color: rgba(28, 103, 124, 1);
  font-weight: 600;
  flex-grow: 1;

  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
`

const CardHeader = styled.div`
  padding: 6px 10px;
`

const CardFooter = styled.div`
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CardContent = styled.div<{ backgroundUrl: string }>`
  background-color: rgba(196, 196, 196, 1);
  flex-grow: 1;
  background-size: cover;
  background-position: center;

  ${(props) => css`
    background-image: url("${props.backgroundUrl}");
  `}
`

export type CardProps = {
  imageUrl: string
  title: string
  footerText: string
  onClick?: () => void
  onHeartClick?: () => void
  selected: boolean
}

export const GalleryCard = (props: CardProps): JSX.Element => {
  const { imageUrl, selected } = props

  const handleHeartClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    if (props.onHeartClick) {
      props.onHeartClick()
    }
  }

  return (
    <CardContainer pointer={!!props.onClick} onClick={props.onClick}>
      <CardHeader>{props.title}</CardHeader>
      <CardContent backgroundUrl={imageUrl}></CardContent>
      <CardFooter>
        <Text>{props.footerText}</Text>
        <Button
          icon={IconType.heart}
          intent="primary"
          selected={selected}
          selectedColor="#FF3B30"
          onClick={handleHeartClick}
        />
      </CardFooter>
    </CardContainer>
  )
}
